import React, { useState, useEffect } from 'react';
import { getApiTeamEmailVerificationStatusUrl } from '../utilities/urlHelper';

const EmailVerificationGuard = ({ sectionTitle, children, closeModal }) => {
    const [isVerified, setIsVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const url = getApiTeamEmailVerificationStatusUrl();

        fetch(url, {
            method: 'GET',
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return response.json();
            })
            .then(({ success, isVerified }) => {
                if (success) {
                    setIsVerified(isVerified);
                } else {
                    setIsVerified(false);
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div>
                <h2>{sectionTitle}</h2>
                <div className="loading">Loading</div>
            </div>
        );
    }

    if (isVerified) {
        return children;
    }

    return (
        <div>
            <div>
                <h2>{sectionTitle}</h2>
                <div className="warning-message rounded mb2 mt2">You need to verify your email to continue</div>
                <div className="right-align">
                    <span className="btn-secondary modal-close" onClick={closeModal}>Close</span>
                </div>
            </div>
        </div>
    );
};

export default EmailVerificationGuard;
